import * as style from './style.module.css';

export const Button = ({ className = '', active, ...props }) => (
    <span className={`${style.button} ${active ? style.active : ''} ${className}`} {...props} />
);

export const Menu = ({ className = '', ...props }) => <div className={`${style.menu} ${className}`} data-test-id="menu" {...props} />;

export const Toolbar = ({ className = '', ...props }) => <Menu className={`${className}`} {...props} />;
